import React, { Component } from 'react'

import about from '../images/paperPlane.png'


const initialState = {
    name: "",
    email: "",
    subject: "",
    status: "",
    message: "",
    nameError: "",
    emailError: "",
    subjectError: "",
    messageError: ""
};

export default class Contact extends Component {
    constructor(props) {
        super(props);
        this.submitForm = this.submitForm.bind(this);
        this.state = {
            status: '',
            name: '',
            email: '',
            subject: '',
            message: '',
            sentMsg: false
        };
    }
    handleChange = event => {

        const isCheckbox = event.target.type === "checkbox";
        this.setState({
            [event.target.name]: isCheckbox
                ? event.target.checked
                : event.target.value
        });
    };
    validate = () => {
        let nameError = "";
        let emailError = "";
        let subjectError = "";
        let messageError = "";
        let passwordError = "";

        if (!this.state.name) {
            nameError = "name cannot be blank";
        }

        if (!this.state.email.includes("@")) {
            emailError = "invalid email";
        }
        if (!this.state.subject) {
            subjectError = "subject cannot be blank";
        }
        if (!this.state.message) {
            messageError = "message cannot be blank";
        }
        if (emailError || nameError || subjectError || messageError) {
            this.setState({ emailError, nameError, subjectError, messageError });
            return false;
        }

        return true;
    };
    submitForm = ev => {

        ev.preventDefault();
        // Validation of the fields
        const isValid = this.validate();
        if (isValid) {
            // If user entered all information poperly, then start the Email request.
            const form = ev.target;
            const data = new FormData(form);
            const xhr = new XMLHttpRequest();
            xhr.open(form.method, form.action);
            xhr.setRequestHeader("Accept", "application/json");
            xhr.onreadystatechange = () => {
                if (xhr.readyState !== XMLHttpRequest.DONE) return;
                if (xhr.status === 200) {
                    form.reset();
                    // clear form
                    this.setState(initialState);
                    this.setState({
                        status: "SUCCESS",
                        sentMsg: true
                    });
                }
            };
            xhr.send(data);
        }
        else {
            this.setState({ status: "ERROR" });
        }
    }
    render() {
        const { status } = this.state;
        return (
            <>
                <section className="ftco-section contact-section ftco-no-pb" id="contact-section">
                    <div className="container">
                        <div className="row justify-content-center mb-5 pb-3">
                            <div className="col-md-7 heading-section text-center ftco-animate">
                                <h1 className="big big-2">Contact</h1>
                                <h2 className="mb-4">Contact Me</h2>
                                <p></p>
                            </div>
                        </div>

                        <div className="row d-flex contact-info mb-5 justify-content-center">
                            <div className="col-md-6 col-lg-3 d-flex ftco-animate">
                                <div className="align-self-stretch box text-center p-4 shadow">
                                    <div className="icon d-flex align-items-center justify-content-center">
                                        <span className="icon-map-signs"></span>
                                    </div>
                                    <div>
                                        <h3 className="mb-4">Address</h3>
                                        <p>SEOUL, SOUTH KOREA</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-3 d-flex ftco-animate">
                                <div className="align-self-stretch box text-center p-4 shadow">
                                    <div className="icon d-flex align-items-center justify-content-center">
                                        <a href="tel://12049632200"><span className="icon-phone2"></span></a>
                                    </div>
                                    <div>
                                        <h3 className="mb-4">Contact Number</h3>
                                        <p><a href="tel://0000000">N/A</a></p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-3 d-flex ftco-animate">
                                <div className="align-self-stretch box text-center p-4 shadow">
                                    <div className="icon d-flex align-items-center justify-content-center">
                                        <a href="mailto:tongil.kim2019@gmail.com"><span className="icon-paper-plane"></span></a>
                                    </div>
                                    <div>
                                        <h3 className="mb-4">Email Address</h3>
                                        <p><a href="mailto:tongil.kim2019@gmail.com">kkimtt1234@gmail.com</a></p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row no-gutters block-9 ">
                            <div className="col-md-6 order-md-last d-flex " >
                                <form onSubmit={this.submitForm} method="POST" action="https://formspree.io/xnqbvaoe"
                                    className="bg-light p-4 p-md-5 contact-form">
                                    <div className="form-group">
                                        <input type="text" name="name" className="form-control" value={this.state.name} onChange={this.handleChange} placeholder="Your Name" />
                                        <div style={{ fontSize: 13, color: "red" }}>
                                            {this.state.nameError}
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <input type="text" name="email" className="form-control" value={this.state.email} onChange={this.handleChange} placeholder="Your Email" />
                                        <div style={{ fontSize: 13, color: "red" }}>
                                            {this.state.emailError}
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <input type="text" name="subject" className="form-control" value={this.state.subject} onChange={this.handleChange} placeholder="Subject" />
                                        <div style={{ fontSize: 13, color: "red" }}>
                                            {this.state.subjectError}
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <textarea name="message" id="" cols="30" rows="7" className="form-control" value={this.state.message} onChange={this.handleChange}
                                            placeholder="Message">
                                            <div style={{ fontSize: 13, color: "red" }}>
                                                {this.state.messageError}
                                            </div>
                                        </textarea>

                                    </div>
                                    <div className="form-group">
                                        <input type="submit" value="Send Message" className="btn btn-primary py-3 px-5" />
                                    </div>
                                    {status === "SUCCESS" ? <i>Message sent!</i> : <b></b>}
                                    {status === "ERROR" && <p style={{ fontSize: 13, color: "red" }}>Ooops! There was an error.</p>}
                                </form>

                            </div>

                            <div className="col-md-6 d-flex ">
                                <div className="img d-flex " style={{ backgroundImage: `url(${about})`, backgroundSize: "400px" }}></div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        )
    }

}
